import { Box, FormControl, Textarea } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { useQueryClient } from '@tanstack/react-query';
import { Field, Form, Formik } from 'formik';

const NegativeSurveyResult = ({ submitSurvey, userComment, submitted, setSubmitted }) => {
  const queryClient = useQueryClient();

  const handleBack = () => {
    queryClient.invalidateQueries({ queryKey: ['submitSurvey'] });
    setSubmitted(false);
  };

  if (submitted) {
    return (
      <Box>
        <Header as="h4">Thank you for completing the survey!</Header>
        <Header as="h4">We'll be in touch. You can close this page now.</Header>
        <Button mt="1rem" size="sm" onClick={handleBack} variant={ButtonVariants.secondary}>
          Back
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Header as="h3">That's No Good!</Header>
      <br />
      <Body1 fontSize="xl">
        How is your plan not meeting your expectations? We'll see if we can find a better one for you.
      </Body1>
      <Formik
        initialValues={{ userComment: userComment || '' }}
        enableReinitialize
        onSubmit={(values) => {
          submitSurvey(values.userComment);
        }}
      >
        {() => (
          <Form>
            <Field name="userComment">
              {({ field, form }) => (
                <FormControl mt={4}>
                  <Textarea
                    w={['20rem', '20rem', '50rem']}
                    size="lg"
                    placeholder="Type Here"
                    id="userComment"
                    {...field}
                  />
                </FormControl>
              )}
            </Field>
            <Button mt="1rem" type="submit" variant={ButtonVariants.primary}>
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default NegativeSurveyResult;
